import React, { useEffect, useState } from "react";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import { IconButton, ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import { Spinner } from "../ui/Spinner";
import { Download } from "@mui/icons-material";
import { UnitSystem } from "../../interfaces/interfaces";

export const PDFView = ({
  document,
  fileName,
  action,
}: {
  document: (unitSystem: UnitSystem) => React.ReactElement;
  fileName?: string;
  action?: () => void;
}) => {
  const [unitSystem, setUnitSystem] = useState<UnitSystem>('imperial');

  useEffect(() => {
    if (action) action();
  }, []);

  const doc = document(unitSystem);

  return (
    <>
      <div
        style={{
          position: "fixed",
          right: "10vw",
          bottom: "50vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 8,
        }}
      >
        <ToggleButtonGroup
          value={unitSystem}
          exclusive
          size="small"
          onChange={(_, val) => { if (val) setUnitSystem(val); }}
          sx={{ backgroundColor: '#fff', borderRadius: 1 }}
        >
          <ToggleButton value="imperial">Imperial</ToggleButton>
          <ToggleButton value="metric">Metric (SI)</ToggleButton>
        </ToggleButtonGroup>
        <PDFDownloadLink
          document={doc}
          fileName={fileName || "OSI DESIGN "}
        >
          {({ loading }) =>
            loading ? (
              <Spinner />
            ) : (
              <Tooltip title="Download">
                <IconButton
                  sx={{
                    backgroundColor: "rgb(251,171,53)",
                    "&:hover": { backgroundColor: "#FFF" },
                  }}
                  size="large"
                >
                  <Download fontSize="large" />
                </IconButton>
              </Tooltip>
            )
          }
        </PDFDownloadLink>
      </div>
      <PDFViewer height={"800vh"}>{doc}</PDFViewer>
    </>
  );
};
